import { gql } from '@apollo/client';

/**
 * 「记录补打面单内部轨迹」外部员工版本（HUB_OPERATOR / SORTING_STAFF 等一线角色调用）。
 * 与 RECORD_LABEL_REPLACEMENT_PRINTING 字段结构一致，仅后端入口方法不同。
 * 使用 GraphQL 别名 `recordLabelReplacementPrinting: recordLabelReplacementPrintingForExternalStaff`
 * 让响应字段名保持一致，下游可直接复用 RecordLabelReplacementPrintingResponse 类型。
 */
export const RECORD_LABEL_REPLACEMENT_PRINTING_FOR_EXTERNAL_STAFF = gql`
    mutation RecordLabelReplacementPrintingForExternalStaff(
        $orderId: Long!
        $warehouseId: Long
        $warehouseName: String
    ) {
        recordLabelReplacementPrinting: recordLabelReplacementPrintingForExternalStaff(
            orderId: $orderId
            warehouseId: $warehouseId
            warehouseName: $warehouseName
        )
    }
`;
